/* eslint-disable */
import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import cn from "classnames";

export const TOGGLE_BUTTON_GROUP_CLASS = "ToggleButtonGroup";
export const TOGGLE_BUTTON_CLASS = "ToggleButton";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      background: "none",
      display: "flex",
      flexWrap: "wrap",
      border: "none",
      borderRadius: 18,
    },
    toggleButton: {
      flex: "1 1 auto",
      color: theme.palette.grey[400],
      [`&.${TOGGLE_BUTTON_CLASS}`]: {
        margin: 1,
        height: 34,
        borderRadius: 17,
        border: "none",
        textTransform: "none",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.grey[600],
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.action.selected,
          fontWeight: "bold",
          color: theme.palette.primary.main,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.primary.dark,
        },
        "&.MuiToggleButton-root.Mui-selected + .MuiToggleButton-root.Mui-selected": {
          marginLeft: 1,
        },
      },
    },
    toggleButtonLabel: {
      fontSize: theme.typography.fontSize,
    },
  });

export type SelectionType = "single" | "multiple";
export type IconPositionType = "before" | "after" | "only" | undefined;

type DimensionValue = any;
type DimensionItem = Record<string, DimensionValue>;

export type DimToggleProps = {
  dimValues: DimensionItem[];
  selectionType: SelectionType;
  value?: DimensionValue | DimensionValue[];
  prevalue?: DimensionValue | DimensionValue[];
  onChange?: (value: DimensionValue | DimensionValue[], event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  className?: string;
  buttonClassName?: string;
  buttonActiveClassName?: string;
  buttonPreActiveClassName?: string;
  iconPosition?: IconPositionType;
};

type DimValue = any;

type Props = DimToggleProps & WithStyles<typeof styles>;

class DimToggle extends React.PureComponent<Props> {
  render() {
    const { classes, dimValues, iconPosition, buttonActiveClassName, 
      buttonPreActiveClassName, buttonClassName, className } = this.props;
    return (
      <ToggleButtonGroup
        value={this.props.value}
        exclusive={this.props.selectionType === "single"}
        onChange={this._handleChange}
        className={cn(TOGGLE_BUTTON_GROUP_CLASS, className)}
        classes={{
          root: classes.root
        }}
      >
        {dimValues &&
          dimValues.map((dimValue, index) => {
            const classNames = [buttonClassName, TOGGLE_BUTTON_CLASS];
            if (buttonActiveClassName && this._checkValue(dimValue)) {
              classNames.push(buttonActiveClassName);
            }
            if (buttonPreActiveClassName && this._checkPrevalue(dimValue)) {
              classNames.push(buttonActiveClassName, buttonPreActiveClassName);
            }
            return (
              <ToggleButton
                key={`period_${dimValue.id || index}`}
                value={dimValue.id}
                className={cn(classNames)}
                disabled={dimValue.disabled}
                classes={{
                  root: classes.toggleButton,
                  label: classes.toggleButtonLabel,
                }}
              >
                {iconPosition === "before" && dimValue.icon}
                {iconPosition === "only" ? dimValue.icon : dimValue.name}
                {iconPosition === "after" && dimValue.icon}
              </ToggleButton>
            );
          })}
      </ToggleButtonGroup>
    );
  }

  private _checkValue = (dimValue: Record<string, any>) => {
    return this._checkDimValue(dimValue, this.props.value);
  }
  private _checkPrevalue = (dimValue: Record<string, any>) => {
    return this._checkDimValue(dimValue, this.props.prevalue);
  }

  private _checkDimValue = (dimValue: Record<string, any>, value?: DimensionValue | DimensionValue[]) => {
    const { id } = dimValue;
    return value && (value === id || (value as DimValue[]).includes(id));
  }

  private _handleChange = (event: React.MouseEvent<HTMLElement, MouseEvent>, value: DimensionValue) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value, event);
    }
  };
}

export default withStyles(styles)(DimToggle);
